import { createStandardAction } from 'typesafe-actions'
import { createErrorAction } from '@chegg-wt/core/utils/actions'
import * as ActionTypes from './constants'

export const displayError = createErrorAction(ActionTypes.ERROR_DISPLAY)

export const clearSearchResultsError = createStandardAction(
  ActionTypes.CLEAR_SEARCH_RESULTS_ERROR
)()
